{
  "messages": {
    "rescheduledOnce": "일정 1회 변경됨",
    "rescheduledTwice": "일정 2회 변경됨",
    "rescheduledCountTimes": "일정 {count}회 변경됨"
  }
}
